import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TiposOperacionesService } from '../../../../services/tipos_operaciones.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tipo-operacion',
  templateUrl: './tipo-operacion.component.html',
  styleUrls: ['./tipo-operacion.component.scss'],
})
export class TipoOperacionComponent implements OnInit {
  form = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(50),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<TipoOperacionComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public tiposOperacionesService: TiposOperacionesService,
    private _snackBar: MatSnackBar
  ) {}
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    this.form.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    )
    this.form.value.id_canales = sessionStorage.getItem('id_canales')
    this.form.value.borrado = 0
    this.tiposOperacionesService.crear(this.form.value).subscribe((data) => {
      console.log('Respuesta',data)
      this.openSnackBar('Tipo Operación creado con éxito', 'x')
      this.dialogRef.close()
    },err=>{
      console.log(err.error.payload)
      this.openSnackBar(err.error.payload,'x')
    });
  }
}
